import { authPost } from "@api";
import { DEPLOYMENT_URL } from "@constants";

import {
  RepoProvisionRequest,
  RepoProvisionResponse,
} from "@pages/setup/types";

export const provisionDeploymentRepo = (
  deploymentId: string,
  repoFullName: string,
  body: RepoProvisionRequest
): Promise<RepoProvisionResponse> => {
  // TODO: Pass the fully constructed yaml from FE to BE so logic lives in one place (FE)
  let url = `${DEPLOYMENT_URL}/${deploymentId}/repos/${repoFullName}/_provision`;
  return authPost<RepoProvisionRequest, RepoProvisionResponse>(url, body);
};
